import React, { useState } from "react";
import { toast } from "sonner";
import { X, Loader2, Sparkles } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";

export function RequestModal({ open, onClose, kind = "product" }) {
  const [f, setF] = useState({ name: "", email: "", phone: "", details: "", link: "", budget: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  if (!open) return null;
  const isCustom = kind === "custom_box";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/requests", { ...f, kind });
      setDone(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const input = "w-full bg-[#FBF5DD] border border-[#0D530E]/15 rounded-xl px-4 py-3 focus:ring-2 focus:ring-[#306D29] focus:outline-none";

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => !loading && onClose()}>
      <div className="bg-white rounded-3xl p-8 max-w-md w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="request-modal">
        <div className="flex justify-between items-start mb-2">
          <div className="flex items-center gap-2 text-[#306D29]"><Sparkles size={18} /><span className="text-xs tracking-[0.2em] uppercase font-semibold">{isCustom ? "Custom Box" : "Request a product"}</span></div>
          <button onClick={onClose} data-testid="request-close"><X size={20} className="text-[#0D530E]" /></button>
        </div>
        {done ? (
          <div className="py-8 text-center" data-testid="request-done">
            <h3 className="font-display text-3xl text-[#0D530E] mb-2">Request received!</h3>
            <p className="text-[#306D29]/80 font-light mb-6">Our team will confirm availability and pricing by email shortly.</p>
            <button onClick={onClose} className="bg-[#306D29] text-[#FBF5DD] font-medium px-7 py-3 rounded-full">Done</button>
          </div>
        ) : (
          <>
            <h3 className="font-display text-3xl text-[#0D530E] mb-1">{isCustom ? "Build your own box" : "Can't find it? We'll source it"}</h3>
            <p className="text-[#306D29]/80 font-light text-sm mb-5">{isCustom ? "Tell us what you'd love inside and your budget — we'll curate it." : "Tell us the exact UK product you need and we'll confirm availability & price."}</p>
            <form onSubmit={submit} className="space-y-3">
              <input required className={input} placeholder="Your name" value={f.name} onChange={set("name")} data-testid="req-name" />
              <input required type="email" className={input} placeholder="Email" value={f.email} onChange={set("email")} data-testid="req-email" />
              <input className={input} placeholder="Phone (optional)" value={f.phone} onChange={set("phone")} data-testid="req-phone" />
              <textarea required rows={3} className={input} placeholder={isCustom ? "What should the box contain?" : "Describe the product (e.g. Boots No7 Serum 30ml)"} value={f.details} onChange={set("details")} data-testid="req-details" />
              {!isCustom && <input className={input} placeholder="Product link (optional)" value={f.link} onChange={set("link")} data-testid="req-link" />}
              <input className={input} placeholder={isCustom ? "Monthly budget (e.g. £80)" : "Budget (optional)"} value={f.budget} onChange={set("budget")} data-testid="req-budget" />
              <button type="submit" disabled={loading} data-testid="req-submit"
                className="w-full bg-[#306D29] hover:bg-[#0D530E] text-[#FBF5DD] font-medium py-3.5 rounded-full flex items-center justify-center gap-2 disabled:opacity-60" style={{ transition: "background-color 0.2s ease" }}>
                {loading && <Loader2 size={18} className="animate-spin" />} Submit request
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
